import React from 'react';

import { Toast } from 'antd-mobile';
import lrz from 'lrz';

import { ajax } from '@utils/http';

import './ImgUpload.less';

export class ImgUpload extends React.Component {
  constructor(props) {
    super(props);
    this.options = this.props.options || {};
  }

  handleImgResize = (e) => {
    let file = e.target.files[0];
    if (!file) {
      return;
    }
    const option = {
      width: this.options.width || 500,
      quality: this.options.quality || 1,
    }
    lrz(file, option).then((result) => {
      ajax({
        url: '/index.php?r=AppData/uploadImg',
        data: {
          img_data: result.base64,
          org: 1
        },
        success: (res) => {
          if (res.status !== 0) {
            Toast.info('图片上传失败，请重试');
            return;
          }
          this.props.complete(res.data);
        }
      })
    })
  }

  render() {
    return (
      <input className="common img-upload" id={this.options.id} type="file" accept="image/jpg,image/jpeg, image/gif, image/bmp, image/jp2, image/x-ms-bmp, image/x-png" onChange={this.handleImgResize}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/img-upload/ImgUpload.jsx